const keys = {
    FAQ_LIST: '/faqs',
    CATEGORIES: '/user-categories',
    SEARCH: '/search',
    GET_TERMS: '/terms/term',
    GET_PRIVACY: '/terms/privacy',
    GET_FIELDS: '/fields',
    GET_CATEGORIES: (field_id: string) => `/categories/${field_id}`,
    GET_STORE_TYPES: '/store-types',
    GET_MARKS_COUNT: '/marks',
    GET_OK_ENG: (page: string) => `/pages/ok/eng/${page}`,
    GET_SETTINGS: '/home',
    GET_APP_HELPS: '/app-helps',
    GET_APP_HELPS_PUBLIC: '/app-helps/public',
    POST_APP_HELPS: (id: number) => `/app-helps/${id}`,
    POST_CHANGE_PASSWORD: '/change-password', // old_password , password , password_confirmation
    POST_LAST_VISIT: '/last-visit',
    GET_SLIDERS: '/sliders',
    GET_FEATURES: '/feature-modals',
    GET_FEATURES_SEEN: (id: number) => `/feature-modals/seen/${id}`,
    GET_POP_UPS: '/pop-ups',
    SEEN_POP_UPS: (id: number) => `/pop-ups/${id}`
};

export default keys;

